/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LanguagesResponse } from '../../models/languages-response';

export interface GetApiPublicLanguages$Params {
  '_locale': 'de' | 'en' | 'fr';
}

export function getApiPublicLanguages(http: HttpClient, rootUrl: string, params: GetApiPublicLanguages$Params, context?: HttpContext): Observable<StrictHttpResponse<LanguagesResponse>> {
  const rb = new RequestBuilder(rootUrl, getApiPublicLanguages.PATH, 'get');
  if (params) {
    rb.path('_locale', params['_locale'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LanguagesResponse>;
    })
  );
}

getApiPublicLanguages.PATH = '/api/public/{_locale}/languages';
